import JSSHA from 'jssha/src/sha1'

const common = {
  YunToken (appid, secretKey, shortid, duration) {
    const expiredTime = parseInt(Date.now() / 1000, 10) + duration
    const rawMask = `${appid}_${expiredTime}_${secretKey}`
    const shaObj = new JSSHA('SHA-1', 'TEXT')
    shaObj.setHMACKey(secretKey, 'TEXT')
    shaObj.update(rawMask)
    const hexMask = shaObj.getHMAC('HEX')
    const token = [shortid, expiredTime, hexMask].join(':')
    return token
  }
}

export default common
